<div *ngIf="show" @fadeInOut class="pms-integration-dialog-container">
  <div class="dialog-header">
    Setup Integration
  </div>

  <app-pms-select-type *ngIf="progress === PharmacyManagementSystemIntegrationStepsEnum.SelectType"
                       [progress]="progress"
                       [selectedType]="selectedPmsType"
                       (integrationTypeSelected)="integrationTypeSelectedHandler($event)"
                       (cancel)="cancel.emit()"
                       (next)="setNextStep($event)"
  ></app-pms-select-type>

  <app-pms-pending-connection *ngIf="selectedPmsType === IntegrationTypeEnum.LibertyRx && progress !== PharmacyManagementSystemIntegrationStepsEnum.SelectType"
                       [progress]="progress"
                       [pharmacyManagementSystemIntegration]="selectedPmsValue"
                       (back)="setNextStep($event)"
                       (next)="setNextStep($event)"
                       (save)="save.emit($event)"
  ></app-pms-pending-connection>

  <app-pioneer-rx-consent-form  *ngIf="selectedPmsType === IntegrationTypeEnum.PioneerRx && progress !== PharmacyManagementSystemIntegrationStepsEnum.SelectType"
    [progress]="progress"
    (back)="setNextStep($event)"
    (next)="setNextStep($event)"
    (ok)="cancel.emit()">
  </app-pioneer-rx-consent-form>

  
  <app-framework-ltc-setup *ngIf="selectedPmsType === IntegrationTypeEnum.FrameworkLTC && progress !== PharmacyManagementSystemIntegrationStepsEnum.SelectType"
    [progress]="progress"
    (back)="setNextStep($event)"
    (next)="setNextStep($event)"
    (ok)="cancel.emit()">
  </app-framework-ltc-setup>
  
</div>
